





























































import { Component, Vue, Prop } from 'vue-property-decorator';
import {User, Info, Device, Column} from '@/types/core';
import { Probe, ProbeReading } from '@/types/nfresh';
import moment from 'moment';

import tippy from 'tippy.js';
import MobileFriendlyRow from '@/components/MobileFriendlyRow.vue';


@Component({
  components:{
    MobileFriendlyRow
  }
})
export default class NfreshReadingRow extends Vue {

  error:string = '';
  @Prop({ default: {},  type: Object}) probeReading!: ProbeReading;

  // to support the header
  @Prop({ default: 0,  type: Number}) index!: number;

  cols:Column[] = [
    { 
      colKey: 'ts',
      colName:'time',
      colStyle:{ width: '160px'}
    },
    { 
      colKey: 'humidity',
      colName:'hum.',
      colStyle:{ width: '70px'},
    },
    { 
      colKey: 'temperature',
      colName:'temp.',
      colStyle:{ width: '70px'},
    }
  ];
  
  async mounted() {
    // nothing yet
    tippy('[data-tippy-content]');
  }

}

